import BodyTypeCheckboxGrid from "./BodyTypeCheckboxGrid";
import ButtonGroup from "./ButtonGroup";
import CheckboxList from "./CheckboxList";
import FeaturedCheckboxList from "./FeaturedCheckboxList";
import React from "react";
export default function FilterContent({ filter, facet, }) {
    if (filter.type === "button") {
        return <ButtonGroup filter={filter} facet={facet}/>;
    }
    if (filter.type === "checkbox" && filter.featuredItems) {
        return <FeaturedCheckboxList filter={filter} facet={facet}/>;
    }
    if (filter.type === "checkbox" && filter.images) {
        return <BodyTypeCheckboxGrid filter={filter} facet={facet}/>;
    }
    if (filter.type === "checkbox") {
        return <CheckboxList filter={filter} facet={facet}/>;
    }
    return <div className="text-gray-500 text-sm">Brak opcji</div>;
}
